define('viewmodels/pages/player/playerTabs',['core/TabSet'], function (TabSet) {

    return function (navigation, getDashboardField, getValuablesField, getReelRacesField) {

        return new TabSet(navigation, 'player', [
            {
                routeConfig: {
                    route: navigation.ROUTES.PLAYER
                },
                title: getDashboardField('tab_title'),
                icon: 'guage',
                css: 'dashboard-tab'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.PLAYER_VALUABLES
                },
                title: getValuablesField('tab_title'),
                icon: 'valuable',
                css: 'valuables-tab'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.REEL_RACES
                },
                title: getReelRacesField('campaign_title'),
                icon: 'prize',
                css: 'reel-races-tab'
            }
        ]);
    };
});

